import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { RequiredThemeKeys, themed } from "@smartsheet/sds-theme-internal";
import { sizes } from "../../../constants/spacing";
import { TypeRampV2 } from "../../typography";
import { labelStyles } from "./FormLabelLabel";

const descriptionStyles = themed({
    color: color("color--text--neutral--weak"),
    marginTop: {
        default: {
            "lodestar-light": sizes.xxSmall,
            "ursa-light": 0,
        },
        afterLabel: {
            "lodestar-light": sizes.xxSmall,
            "ursa-light": 3,
        },
    },
});

interface FormLabelDescriptionProps {
    themeMode: RequiredThemeKeys;
}

export const FormLabelDescription = styled(TypeRampV2)<FormLabelDescriptionProps>`
    color: ${({ themeMode }) => descriptionStyles.color(themeMode)};
    cursor: default;
    &:not(:empty) {
        margin-bottom: ${({ themeMode }) => labelStyles.margin(themeMode)}px;
        margin-top: ${({ themeMode }) => descriptionStyles.marginTop.default(themeMode)}px;
        label + & {
            margin-top: -${({ themeMode }) => descriptionStyles.marginTop.afterLabel(themeMode)}px;
        }
    }
`;
